import type { ComponentProps } from 'react';

import type { EventView } from '@ndvr/customer-api';

import { stripHtmlToText } from 'utils';
import { useListTasksByHouseholdQuery } from 'views/tasks/task-queries';

import { RelatedMeetingNotesList } from '../HouseholdNotes/RelatedMeetingNotesList';
import { useGetMeetingBot } from './events-queries';

export type EventNoteView = NonNullable<ComponentProps<typeof RelatedMeetingNotesList>['notes']>[number];
export type EventTaskView = NonNullable<ReturnType<typeof useListTasksByHouseholdQuery>['data']>[number];
export type EventMeetingBot = NonNullable<ReturnType<typeof useGetMeetingBot>['data']>;
type EventTitleMarkerInput = Partial<Pick<EventView, 'dateSpan' | 'isDateSpan' | 'clientHouseholdGUID'>>;

export const NON_JOINED_MEETING_BOT_STATUSES = [
    'COMPLETED',
    'PROCESSING',
    'ENDED',
    'FAILED',
    'FATAL_ERROR',
    'SCHEDULED',
    'CANCELLED',
];

export const SCHEDULED_MEETING_BOT_STATUSES = ['SCHEDULED', 'STAGED'];

export function getStatusTagType(status: string): 'info' | 'neutral' | 'positive' | 'highlight' | 'negative' {
    switch (status) {
        case 'SCHEDULED':
            return 'neutral';
        case 'COMPLETED':
            return 'positive';
        case 'FAILED':
            return 'negative';
        case 'CANCELLED':
            return 'highlight';
        default:
            return 'info';
    }
}

export function getParticipantDisplayNames(participants: EventView['participants']): string {
    return (participants ?? []).map((participant) => participant.name || participant.email).join(', ');
}

export function getEventTitleMarkerClassName(event: EventTitleMarkerInput): string {
    if (event.dateSpan || event.isDateSpan) {
        return 'border border-[#CEC6CA] bg-white';
    }

    if (event.clientHouseholdGUID) {
        return 'bg-seafoam-100';
    }

    return 'border border-[#C2D4D7] bg-white';
}

export function getTaskPreview(description?: string | null): string {
    if (!description) {
        return '';
    }

    const previewText = stripHtmlToText(description);
    return previewText.length > 120 ? `${previewText.substring(0, 120)}...` : previewText;
}
